module.exports = __webpack_public_path__ + "img/logo-menu-branco.fea7cc54.png";